import { NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ThemeModule } from './theme/theme.module';
import { CommonModule, registerLocaleData } from "@angular/common";
import localeEs from "@angular/common/locales/es";
registerLocaleData(localeEs);
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FirebaseModule } from './firebase/firebase.module';
import { NgxLoadingXConfig, POSITION, SPINNER, NgxLoadingXModule } from 'ngx-loading-x';
import { QRCodeModule } from 'angularx-qrcode';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LoginComponent } from './authentication/login/login.component';
import { ForgotPasswordComponent } from './authentication/forgot-password/forgot-password.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { ComandaComponent } from './components/comanda/comanda.component';
import { PreviewQrComponent } from './pages/local-orders/modals/preview-qr/preview-qr.component';
import { NotFoundComponent } from './authentication/not-found/not-found.component';
import { ConfirmPhoneComponent } from './components/confirm-phone/confirm-phone.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ChangePasswordComponent } from './components/profile/change-password/change-password.component';
import { ChangeForgotPasswordComponent } from './authentication/change-forgot-password/change-forgot-password.component';
import { NgPipesModule } from 'ngx-pipes';

const ngxLoadingXConfig: NgxLoadingXConfig = {
  show: false,
  bgBlur: 2,
  bgOpacity: 5,
  bgLogoUrl: '',
  bgLogoUrlPosition: POSITION.topLeft,
  bgLogoUrlSize: 100,
  spinnerType: SPINNER.wanderingCubes,
  spinnerSize: 120,
  spinnerColor: '#dd0031',
  spinnerPosition: POSITION.centerCenter,
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ConfirmModalComponent,
    ComandaComponent,
    PreviewQrComponent,
    NotFoundComponent,
    ConfirmPhoneComponent,
    ProfileComponent,
    ChangePasswordComponent,
    ChangeForgotPasswordComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    ThemeModule,
    CommonModule,
    BrowserAnimationsModule,
    NgbModule,
    FirebaseModule,
    FormsModule,
    NgxLoadingXModule.forRoot(ngxLoadingXConfig),
    QRCodeModule,
    NgPipesModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es' }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
